import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from '../base/util/base.service';
import { buscarComunicados, comunicadoLido, comunicadoEstouDeAcordo, buscarUltimosComunicados } from '../base/util/url-util';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class ComunicadosService extends BaseService {

    constructor(public http: HttpClient,public messageService: MessageService) { 
        super(http,messageService);
    }

    public buscarComunicados(quantidade?: number){
        return this.get(buscarComunicados(quantidade));
    }

    public buscarUltimosComunicados(quantidade?: number){
        return this.get(buscarUltimosComunicados(quantidade));
    }

    public marcarLido(comunicadoId: string){
        return this.get(comunicadoLido(comunicadoId));
    }

    public estouDeAcordo(comunicadoId: string){
        return this.get(comunicadoEstouDeAcordo(comunicadoId));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/comunicados/comunicados.service.ts